export default {
  namespased: true,

  state: {
    id: '',
    auto_id: '',
    owner_type: '',
    price: '',
    mileage: '',
    insurance_office: '',
    insurance_no: '',
    damages: '',
    attachments: {
      seller_ceidg_or_krs: false,
      seller_authorization: false,
      buyer_ceidg_or_krs: false,
      buyer_authorization: false,
      additional_attachments: ""
    }
  },

  getters: {},

  actions: {},

  mutations: {
    setAuto(state, id) {
      state.auto_id = id
    },

    updateAgreement(state, payload) {
      if (payload.obj === 'damages') {
        const merged = [].concat.apply([], payload.value)

        state[payload.obj] = merged
      } else state[payload.obj] = payload.value
    },

    updateAttachment(state, payload) {
      console.log(payload.value)
      if(payload.obj == "additional_attachments"){
        state.attachments[payload.obj] = String(payload.value).toLowerCase()
        
      }else{
        state.attachments[payload.obj] =
        String(payload.value).toLowerCase() === 'true'
      }

    }
  }
}
